import { CommonModule } from "@angular/common";
import { inject, NgModule, provideAppInitializer } from "@angular/core";
import { NavigationUtilitiesService } from "@common/route/navigation-utilities.service";
import { AuthorisationService } from "./authorisation.service";
import { AdaptIfAuthorisedDirective } from "./if-authorised.directive";
import { initialiseNavigationAccessVerificationCallback } from "./navigation-access-verification-initialiser";

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
        AdaptIfAuthorisedDirective,
    ],
    declarations: [
        AdaptIfAuthorisedDirective,
    ],
    providers: [
        provideAppInitializer(() => initialiseNavigationAccessVerificationCallback(inject(AuthorisationService), inject(NavigationUtilitiesService))()),
    ],
})
export class AdaptAuthorisationModule { }
